import Button from "../../../button/button";
import InputAnimated from "../../../inputAnimated/inputAnimated";
import Modal from "../../../modal/modal";
import PasswordAlert from "../../../passwordAlert/passwordAlert";
import './ExchangeRateRegister.scss'
import React, { useState } from "react";
import Axios from "axios";
import Alert from "../../../alert/Alert";
const ExchangeRateRegister = ({ onClose, isOpen }) => {
    // Define el estado para los handlers del modal
    const [modalHandlers, setModalHandlers] = useState({
        handleAcceptPassword: () => { },
        handleCancelPassword: () => { },
    });
    const [exchangeRate, setExchangeRate] = useState('')
    //ALERT
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])
    // PasswordModal Confirm
    const [isModalPasswordConfirmOpen, setIsModalPasswordConfirmOpen] = useState(false);
    const [modalPasswordDetailAction, setModalPasswordDetailAction] = useState('Ingrese las credenciales')
    const [modalPasswordDetailTitle, setModalPasswordDetailTitle] = useState('Identificacion')
    const [disabledButton, setDisabledButton] = useState(false)
    const handleConfirmExchangeRate = async () => {
        setDisabledButton(true)
        const checkPasswordConfirm = await ConfirmActionPassword();
        const { status, message } = checkPasswordConfirm;

        if (!status) {
            setDisabledButton(false)
            return showAlert('info', message);
        }

        if (!exchangeRate) {
            setDisabledButton(false)
            return showAlert('danger', 'Ingresa el tipo de cambio del dólar');
        }
        if (exchangeRate < 0) {
            setDisabledButton(false)
            return showAlert('danger', 'El tipo de cambio no puede ser negativo');
        }

        const handleExchangeRate = await handleUSDUpdateExchangeRate(exchangeRate);
        const { status: statusEc, message: msgEc } = handleExchangeRate;

        const alertType = statusEc === 200 ? 'success' : 'info';
        showAlert(alertType, msgEc);
        if (statusEc === 200) {
            setTimeout(() => {
                onClose()
                setDisabledButton(false)
            }, 2000);
        } else {
            setDisabledButton(false)

        }
    };

    // Función auxiliar para mostrar alertas
    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts(oldArray => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };

    const ConfirmActionPassword = () => {
        return new Promise((resolve) => {
            setIsModalPasswordConfirmOpen(true);

            const handleAcceptPassword = async (formValues) => {
                const { email, password } = formValues;

                if (!email || !password) {
                    return showAlert('danger', 'Ingrese el correo y la contraseña para verificar sus credenciales.');
                }

                try {
                    const response = await handleConfirmationReceptionistInCharge(formValues);
                    let status = response.status;

                    if (response.hasOwnProperty("auth")) {
                        status = 202;
                    }

                    switch (status) {
                        case 200:
                            setIsModalPasswordConfirmOpen(false);
                            resolve({ status: true, message: "Edición Permitida" });
                            break;
                        case 201:
                            resolve({ status: false, message: 'Credenciales rechazadas para realizar la edición.' });
                            break;
                        case 202:
                            resolve({ status: false, message: "Credenciales expiradas" });
                            break;
                        default:
                            resolve({ status: false, message: "Error desconocido al verificar credenciales." });
                            break;
                    }
                } catch (error) {
                    console.error(error);
                    resolve({ status: false, message: "Error al verificar credenciales." });
                }
            };

            const handleCancelPassword = () => {
                setIsModalPasswordConfirmOpen(false);
                resolve(false);
            };

            setModalHandlers({ handleAcceptPassword, handleCancelPassword });
        });
    };


    const handleConfirmationReceptionistInCharge = async (form) => {
        try {
            const res = await Axios.post(process.env.REACT_APP_API_URL + "confirmReceptionistInChargePatch/", {
                email: form.email,
                password: form.password,
            }, {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            })
            return res.data
        } catch (error) {
            console.log(error)
        }
    }

    const handleUSDUpdateExchangeRate = async (value) => {
        try {
            const res = await Axios.patch(process.env.REACT_APP_API_URL + "patchUSDCurrency/", {
                exchange_rate: value
            }, {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            })
            return res.data
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal isOpen={isOpen} onClose={onClose} overlayClick={false}>
            <div className="exchange-rate-register">
                <h1 className="title-1">Tipo de cambio</h1>
                <InputAnimated type="number" placeholder='Ingresa tipo de cambio' value={exchangeRate} onChange={(e) => setExchangeRate(e.target.value)} />
                <div className="confirm-buttons-section">
                    <Button disabled={disabledButton} text='Cancelar' backgroundColor="red" onClick={onClose} />
                    <Button disabled={disabledButton} text='Confirmar' onClick={handleConfirmExchangeRate} />

                </div>
            </div>
            <div className="divAlert">
                <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
            </div>
            <PasswordAlert
                isOpen={isModalPasswordConfirmOpen}
                handleAccept={modalHandlers.handleAcceptPassword}
                handleCancel={modalHandlers.handleCancelPassword}
                text={modalPasswordDetailAction}
                title={modalPasswordDetailTitle}
            />
        </Modal>
    )
}
export default ExchangeRateRegister;